import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Web\AiImageGeneration\ShowAiGenerationCreditsRemainingController::__invoke
* @see Http/Controllers/Web/AiImageGeneration/ShowAiGenerationCreditsRemainingController.php:16
* @route '/ai-products/generation/credits-remaining'
*/
const ShowAiGenerationCreditsRemainingController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: ShowAiGenerationCreditsRemainingController.url(options),
    method: 'get',
})

ShowAiGenerationCreditsRemainingController.definition = {
    methods: ["get","head"],
    url: '/ai-products/generation/credits-remaining',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Web\AiImageGeneration\ShowAiGenerationCreditsRemainingController::__invoke
* @see Http/Controllers/Web/AiImageGeneration/ShowAiGenerationCreditsRemainingController.php:16
* @route '/ai-products/generation/credits-remaining'
*/
ShowAiGenerationCreditsRemainingController.url = (options?: RouteQueryOptions) => {
    return ShowAiGenerationCreditsRemainingController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Web\AiImageGeneration\ShowAiGenerationCreditsRemainingController::__invoke
* @see Http/Controllers/Web/AiImageGeneration/ShowAiGenerationCreditsRemainingController.php:16
* @route '/ai-products/generation/credits-remaining'
*/
ShowAiGenerationCreditsRemainingController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: ShowAiGenerationCreditsRemainingController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Web\AiImageGeneration\ShowAiGenerationCreditsRemainingController::__invoke
* @see Http/Controllers/Web/AiImageGeneration/ShowAiGenerationCreditsRemainingController.php:16
* @route '/ai-products/generation/credits-remaining'
*/
ShowAiGenerationCreditsRemainingController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: ShowAiGenerationCreditsRemainingController.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Web\AiImageGeneration\ShowAiGenerationCreditsRemainingController::__invoke
* @see Http/Controllers/Web/AiImageGeneration/ShowAiGenerationCreditsRemainingController.php:16
* @route '/ai-products/generation/credits-remaining'
*/
const ShowAiGenerationCreditsRemainingControllerForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: ShowAiGenerationCreditsRemainingController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Web\AiImageGeneration\ShowAiGenerationCreditsRemainingController::__invoke
* @see Http/Controllers/Web/AiImageGeneration/ShowAiGenerationCreditsRemainingController.php:16
* @route '/ai-products/generation/credits-remaining'
*/
ShowAiGenerationCreditsRemainingControllerForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: ShowAiGenerationCreditsRemainingController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Web\AiImageGeneration\ShowAiGenerationCreditsRemainingController::__invoke
* @see Http/Controllers/Web/AiImageGeneration/ShowAiGenerationCreditsRemainingController.php:16
* @route '/ai-products/generation/credits-remaining'
*/
ShowAiGenerationCreditsRemainingControllerForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: ShowAiGenerationCreditsRemainingController.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

ShowAiGenerationCreditsRemainingController.form = ShowAiGenerationCreditsRemainingControllerForm

export default ShowAiGenerationCreditsRemainingController